import {Base,Axios} from "@/api/Base"

export class GiUpload extends Base {
    path = "gi/upload"
    upload(param){
        return Axios.post(this.path, param, { 
          headers: {
          "Content-Type":"multipart/form-data"
          }
        })
    }
}